import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  communicationsData: {},
  communicationsLoader: false,
  communicationDetail: {},
  communicationDetailLoader: false,
  resendCommunicationDetails: {},
  resendCommunicationLoader: false,
  totalCommunications: 0,
};

const communication = createSlice({
  name: "communication",
  initialState,
  reducers: {
    getCommunicationsData(state) {
      state.communicationsLoader = true;
    },
    fetchCommunicationsData(state, action) {
      state.communicationsData = action.payload;
      state.totalCommunications = action.payload?.count ?? 0;
      state.communicationsLoader = false;
    },
    getCommunicationDetail(state) {
      state.communicationDetailLoader = true;
      state.communicationDetail = {};
    },
    fetchCommunicationDetail(state, action) {
      state.communicationDetail = action.payload;
      state.communicationDetailLoader = false;
    },
    clearCommunicationDetail(state) {
      state.communicationDetail = {};
      state.communicationDetailLoader = false;
    },
    resendCommunication(state) {
      state.resendCommunicationDetails = {};
      state.resendCommunicationLoader = true;
    },
    fetchResendCommunication(state, action) {
      state.resendCommunicationDetails = action.payload;
      state.resendCommunicationLoader = false;
    },
    clearResendCommunication(state) {
      state.resendCommunicationDetails = {};
      state.resendCommunicationLoader = false;
    },
  },
});

export const communicationAction = communication.actions;
export default communication.reducer;
